export const STATUS_OPTIONS = [
  {
    label: "Finalizado",
    value: "finalizado",
  },
  {
    label: "Processando",
    value: "processando",
  },
];